import Select, { Props } from "react-select";
import { FieldSkeleton } from "./FieldSkeleton";
import { getSelectStyles } from "./select-styling";

type OwnProps = {
  innerRef?: any;
  errorMessage?: string;
  label?: string;
  helperText?: string;
  width?: string;
} & Props;

export const SelectField = ({
  innerRef,
  errorMessage,
  label,
  helperText,
  value,
  width,
  ...rest
}: OwnProps) => {
  return (
    <FieldSkeleton
      errorMessage={errorMessage}
      helperText={helperText}
      label={label}
      width={width}
    >
      <Select
        ref={innerRef}
        menuPosition="fixed"
        value={value || ""}
        isOptionDisabled={(option) => {
          return (option as { isDisabled: boolean }).isDisabled;
        }}
        styles={getSelectStyles({ isMulti: rest.isMulti, errorMessage })}
        {...rest}
      />
    </FieldSkeleton>
  );
};
